export default "/fonts/vendor/tinymce/skins/lightgray/tinymce-small.svg?4d989c2c7a53e2afa18f67e279646189";